import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Text, H2, FlexPanel, Button } from 'Common';
import { showToast } from 'Utils/toastUtils';
import { t } from 'Utils/localization/i18next';
import analytics from 'Utils/analytics/analyticsWrapper';
import { getRedirectURLForUpdateEmail } from 'Redux/profile/profileThunks';
import arrowRight from '@ingka/ssr-icon/paths/arrow-right';
import styles from './SectionReadContainer.module.scss';

class EmailSectionReadContainer extends React.PureComponent {
  onEdit = async e => {
    e.preventDefault();
    const redirectURL = await this.props.getRedirectURLForUpdateEmail();
    if (redirectURL) {
      analytics.userProfileFormUpdate({
        status: 'started',
        form: `${this.props.profileType}-dashboard-change-email`
      });
      window.location = redirectURL;
    } else {
      showToast(t('forms.errors.title'), `- ${t('forms.errors.generic')}`);
    }
  };

  render() {
    return (
      <React.Fragment>
        <div className={styles['dashboard-section-read']}>
          <FlexPanel spread className={styles['dashboard-section-read-title']}>
            <H2 tagName="h2" headingSize="m" margin={false}>
              {t(this.props.title)}
            </H2>
            <Button
              className={styles['edit-link']}
              size="small"
              type="tertiary"
              id="user-login-ciam-edit-link"
              onClick={this.onEdit}
              ssrIcon={arrowRight}
              href="#"
            >
              {t('dashboard.account.edit.email')}
            </Button>
            <Button
              className={styles['edit-link-mobile']}
              id="user-login-ciam-edit-link-mobile"
              onClick={this.onEdit}
              aria-label={t('dashboard.account.edit.email')}
              size="small"
              type="tertiary"
              ssrIcon={arrowRight}
              iconOnly
              href="#"
            ></Button>
          </FlexPanel>
          <Text marginBottom="s">{this.props.children}</Text>
          <Text
            bold
            colour={
              this.props.emailVerification
                ? 'feedback-confirmation'
                : 'semantic-caution'
            }
          >
            {this.props.emailVerification
              ? t('common.verified')
              : t('common.unverified')}
          </Text>
        </div>
      </React.Fragment>
    );
  }
}

EmailSectionReadContainer.propTypes = {
  profileType: PropTypes.string,
  editForm: PropTypes.string,
  title: PropTypes.string,
  emailVerification: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  // From Redux/Thunks
  getRedirectURLForUpdateEmail: PropTypes.func.isRequired
};

const mapStateToProps = state => {
  return {
    ...state,
    emailVerification: state.verification.emailVerifiedStatus,
    profileType: state.profile.profileType
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ getRedirectURLForUpdateEmail }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailSectionReadContainer);
